import type { KeyboardEvent } from 'react';

/**
 * KD3 S2065 (BUG-S2065-001) — ช่องจำนวนเงิน/จำนวนชิ้น (`<input type="number">` แบบ controlled)
 * ตัวอักษร e / E / + / - ทำให้ค่ากลางทางไม่ใช่ตัวเลข → React คืนค่าเดิมให้ช่องทันที แล้วตัวถัดไปต่อท้าย
 * เช่นพิมพ์ "1e4" (ตั้งใจ 10,000) ได้ "14" · พิมพ์ "-5" ได้ "05" แล้วส่ง +5 ไปบันทึกเงียบ ๆ
 * ช่องเงิน/จำนวนในระบบไม่มีค่าติดลบหรือเลขยกกำลัง → กันตั้งแต่ตอนกดแป้น
 */
const BLOCKED_KEYS = new Set(['e', 'E', '+', '-']);

export function blockNonNumericKeys(e: KeyboardEvent<HTMLInputElement>): void {
  if (BLOCKED_KEYS.has(e.key)) e.preventDefault();
}
